<template lang="pug">
div.animated.fadeIn
  b-card
    div.row
      div.col-sm-5
        h4.card-title.mb-0
          | Interactions (Historical)
        div.small.text-muted
          | Displaying Past Interactions
        //- b-btn.pull-right(type='button', variant='primary')
          i.icon-cloud-download
          |   Export
    br
    div(v-if='loading')
      | {{loadingText}}
    div(v-else)
      div(v-if='tableItemsFlag.length > 0')
        app-interactionsTable(:data='tableItemsFlag', :label='tableFieldsFlag', rowClick)
        br
      app-interactionsTable(:data='tableItems', :label='tableFields', v-if='!boss', rowClick)
      br
      div.row
        div.col-sm-7
          b-pagination-nav(class='pagination-area', base-url='/#/interactions/historical?page=', align='right', size='md', :total-rows='pages' v-model='currentPage', :number-of-pages='totalPage')
        div.col-sm-2
          b-form(@submit='paginateTo')
            b-input-group(size='')
              b-form-input(placeholder='Page number', v-model='inputPageNumber', :state='inputPageNumberState')
              b-input-group-button(slot='right')
                b-btn(variant='primary', v-b-tooltip.hover='"Paginate"', type='submit')
                  i.fa.fa-columns
          label(style='color: red;', v-if='inputPageNumberState == false')
            | Wrong input
</template>

<script>
import { db } from '@/firebase'
import { parseMessage } from '../filter'
import { routeByURL, checkURLChanges } from '../methods/routerPagination'

const msgsRef = db.ref('newestChats')
const usersRef = db.ref('users')
const flagRef = db.ref('flags')
const dRef = db.ref('dashboard')

function fullNameElseID(key, val) {
  if (val.firstName && val.lastName) {
    return val.firstName + ' ' + val.lastName
  } else if (val.name) {
    return val.name
  } else if (val.shortID) {
    return 'Guest'
    // this is short key
    // return val.shortID
  } else {
    return 'Guest'
    // this is long key
    // return key
  }
}

export default {
  name: 'dashboard',
  props: ['boss'],
  data() {
    return {
      firstSendObj: {},
      inputPageNumber: '',
      timeout: [],
      currentPage: 1,
      pages: Number,
      userAccessLevel: this.$store.state.profile.accessLevel,
      totalPage: 0,
      loading: true,
      usersCount: 0,
      loadingPause: null,
      actions1: [{ name: 'View More' }],
      loadingText: 'Loading...',
      tableItems: [],
      tableFields: {
        avatar: {
          label: 'Status',
        },
        messageId: {
          label: 'Customer Name / ID',
        },
        message: {
          label: 'Message',
        },
        flagHandleBy: {
          label: 'Resolved By',
        },
        firstInteraction: {
          label: 'First Interaction',
        },
        numTimestamp: {
          label: 'Last Interaction',
        },
      },
      tableItemsFlag: [],
      tableFieldsFlag: {
        avatar: {
          label: 'Status',
        },
        messageId: {
          label: 'Customer Name / ID',
        },
        message: {
          label: 'Message',
        },
        flagHandleBy: {
          label: 'Resolved By',
        },
        firstInteraction: {
          label: 'First Interaction',
        },
        numTimestamp: {
          label: 'Last Interaction',
        },
      },
    }
  },
  computed: {
    inputPageNumberState() {
      if (this.inputPageNumber == '' || (!isNaN(parseInt(this.inputPageNumber)) && parseInt(this.inputPageNumber) > 0 && parseInt(this.inputPageNumber) <= this.totalPage)) {
        return null
      } else {
        return false
      }
    },
  },
  methods: {
    paginateTo(e) {
      e.preventDefault()
      if (!isNaN(parseInt(this.inputPageNumber)) && parseInt(this.inputPageNumber) > 0 && parseInt(this.inputPageNumber) <= this.totalPage) {
        this.currentPage = parseInt(this.inputPageNumber)
        document.location.hash = `interactions?page=${parseInt(this.inputPageNumber)}`
      }
    },
    paginate(p) {
      const self = this
      return new Promise(async (resolve) => {
        var msgs
        var msgsFlag
        var users = {}
        var flags
        var messageKey
        msgsRef.limitToLast((p * 10) + 25).once('value', async (snapshot) => {
          msgs = []
          msgsFlag = []
          users = {}
          var keys = []
          var numOfFlag = 0
          var currentNumFlag = 0
          var iterator = 0
          var promiseArray = []
          promiseArray.push(flagRef.once('value').then((snapshot) => {
            numOfFlag = snapshot.numChildren()
            flags = {}
            messageKey = {}
            var senderID
            if (window.localStorage.getItem('firstSendObj') !== null) {
              self.firstSendObj = JSON.parse(window.localStorage.getItem('firstSendObj'))
            }
            snapshot.val() && Object.entries(snapshot.val()).forEach(
              function([key, val]) {
                try {
                  senderID = val.senderID || val.userID
                  flags[senderID] = val.agent || ' '
                  messageKey[senderID] = key
                } catch (error) {
                  // console.log('no uid: ' + error)
                }
              })
          }))
          Object.entries(self.firstSendObj).forEach(
            function([key, val]) {
              if (messageKey.hasOwnProperty(key) === false) {
                delete self.firstSendObj[key]
                window.localStorage.setItem('firstSendObj', JSON.stringify(self.firstSendObj))
              }
            })
          // var prev = [] // check if previous record exist
          snapshot.forEach((child) => {
            keys.unshift(child.key)
            try {
              promiseArray.push(usersRef.child(child.val().userID).once('value').then((ss) => {
                users[child.val().userID] = ss.val()
              }))
            } catch (error) {}
          })
          await Promise.all(promiseArray)
          for (var k of keys) {
            if (numOfFlag <= currentNumFlag && iterator >= (p * 10)) {
              break
            }
            try {
              if (iterator >= (p * 10)) {
                if (!snapshot.val()[k].flagged) {
                  continue
                }
              }
              var val = snapshot.val()[k]
              var senderID = val.senderID || val.userID
              if (users[senderID]) {
                val.username = fullNameElseID(senderID, users[senderID])
                val.url = users[senderID].profilePic || 'static/img/avatars/0.png'
                val.status = users[senderID].status || 'danger'
                val.takeover = users[senderID].takeover || false
                val.firstInteraction = users[senderID].firstInteraction || '-'
                val.flagHandleBy = users[senderID].flagHandleBy || ['Not Applicable']
              } else {
                val.username = senderID
                val.url = 'static/img/avatars/0.png'
                val.status = 'danger'
                val.takeover = false
                val.firstInteraction = '-'
                val.flagHandleBy = ['Not Applicable']
              }
              // Massage msg
              var cutOff = 50
              var message = parseMessage(val.message, cutOff)
              var flagHandleByString
              if (val.flagHandleBy != ['Not Applicable']) {
                flagHandleByString = val.flagHandleBy.join(', ')
              } else {
                flagHandleByString = 'Not Applicable'
              }
              var msg = {
                avatar: { url: val.url, status: val.status, tooltip: k },
                userId: senderID,
                rawMsg: val.message,
                messageId: val.username,
                flagHandleBy: { id: senderID, flagHandleBy: val.flagHandleBy, flagHandleByString },
                numTimestamp: val.timestamp,
                firstInteraction: val.firstInteraction,
                message: message,
              }
              if (val.flagged == true) {
                msg._rowVariant = 'danger'
                for (var j = 0; j < msgsFlag.length; j++) {
                  if (msgsFlag[j].userId == msg.userId) {
                    msgsFlag.splice(j, 1)
                  }
                }
                msgsFlag.unshift(msg)
                currentNumFlag += 1
              } else {
                if (iterator >= (p * 10) - 10) {
                  senderID && msgs.push(msg)
                }
                msgs.length = msgs.length <= 10 ? msgs.length : 10
                iterator += 1
              }
            } catch (error) {
              // console.log('no uid: ' + error)
            }
          }
          self.tableItemsFlag = msgsFlag
          self.tableItems = msgs
          resolve('completed')
        })
      })
    },
  },
  watch: {
    currentPage() {
      var p = this.currentPage
      var that = this
      dRef.on('value', (snapshot) => {
        this.paused = snapshot.child('pauseToggle').val()
      })
      clearInterval(this.interval)
      // var f = (p * 10) - 10
      this.loading = true
      this.paginate(p).then((res) => {
        that.loading = false
      })
      this.inputPageNumber = this.currentPage
    },
  },
  mounted: async function() {
    this.currentPage = routeByURL('#/interactions/historical')
    dRef.on('value', (snapshot) => {
      this.paused = snapshot.child('pauseToggle').val()
    })
    msgsRef.once('value').then((snapshot) => {
      this.pages = snapshot.numChildren()
      this.totalPage = Math.trunc(this.pages / 10) + 1
    })
    const self = this
    this.paginate(this.currentPage).then((res) => {
      self.loading = false
    })
    checkURLChanges('#/interactions')
  },
  beforeDestroy: function() {
    clearInterval(this.interval)
    msgsRef.off('value')
    dRef.off('value')
  },
}
</script>



// WEBPACK FOOTER //
// src/views/Interactions.vue?cb42ddd6